import React, { useState } from "react";
import { useAppText } from "src/commun/composants/AppText";
import { deleteAccount } from "src/app/api/AccountApi";
import AppPopin from "src/commun/composants/AppPopin/AppPopin";
import ConfirmationPopin from "src/commun/composants/ConfirmationPopIn/ConfirmationPopin";
import { useAppState } from "src/app/state/StateProvider";
import AppEnv from "src/app/AppEnv";
import { DictionnaireApi } from "src/app/api/DictionnaireApi";


const DeleteAccount = () => {
  const { tString } = useAppText();
  const [, dispatch] = useAppState();
  const [{ configuration }] = useAppState();
  const [popInConfirmationDelete, setPopInConfirmationDelete] = useState(false);

  const onLogout = () => {
    if (AppEnv.typeAuth === "LDAP") {
      fetch(DictionnaireApi.logoutURL.getUrl(), { method: "POST" }).then(() => {
        dispatch({ type: "logout" });
        window.location.href = `/`;
      });
    } else {
      fetch(DictionnaireApi.logoutURL.getUrl(), { method: "POST" }).then(() => {
        window.location.href = configuration.logoutUrl;
      }).catch(() =>{  window.location.href = configuration.logoutUrl;});
    }
  };

  return  (
    <>
      <input
        className="btn__primary tag--danger mt-20 mb-10 btn--full--xs"
        type="submit"
        name="annuler"
        onClick={() => setPopInConfirmationDelete(true)}
        value={tString("action.supprimer.compte")}
      />

      <AppPopin
        opened={popInConfirmationDelete}
        onModalClick={() => setPopInConfirmationDelete(false)}
      >
        <ConfirmationPopin
          text="confirmation.supprimer.compte"
          validerLabel="confirmation.supprimer.oui"
          validerHandler={() => {
            deleteAccount().then(() => {
              onLogout();
            });
          }}
          annulerLabel="confirmation.supprimer.non"
          annulerHandler={() => setPopInConfirmationDelete(false)}
        />
      </AppPopin>
    </>
  );
};

export default DeleteAccount;